import React, { useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./Member.css";
import Navbar from "./Navbar";
import SubAccouttable from "./SubAccouttable";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./header";
import ApiConfig from "../../common/config/ApiConfig";
import {
  groupPermissions,
  getPermissionCategoryLabelKey,
  getPermissionLabel,
} from "../../common/utils/permissionCategories";
import { useLanguage } from "../../common/i18n/LanguageContext";

function Subaccount() {
  const { t } = useLanguage();
  const [open, setOpen] = React.useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [vpassword, setvPassword] = useState(false);

  const [suffix1, setSuffix1] = useState(0);
  const [suffix2, setSuffix2] = useState(0);
  const [suffix3, setSuffix3] = useState(0);

  const [status, setStatus] = useState(1);
  const [permission, setPermission] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const user = localStorage.getItem("user");
  const prefix = user ? user.slice(-4) : "";
  const [reload, setReload] = useState(0);

  const handleClose = () => {
    setOpen(false);
    setUsername(prefix);
    setPassword("");
    setStatus(1);
    setPermission([]);
    setvPassword(false);
    setSuffix1(0);
    setSuffix2(0);
    setSuffix3(0);
  };

  const handleClickOpen = async () => {
    setUsername(prefix);
    setOpen(true);

    const result = await ApiConfig.get("/permissions");
    if (result.resCode !== 200) {
      toast.error(result.message || t("subaccount_permissions_fetch_error"), {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    setPermissions(result.data);
  };

  const handlepermission = (id) => {
    if (permission.includes(id)) {
      setPermission(permission.filter((p) => p !== id));
    } else {
      setPermission([...permission, id]);
    }
  };

  const handleSelectAllPermissions = () => {
    if (permission.length === permissions.length) {
      setPermission([]);
    } else {
      setPermission(permissions.map((item) => item.id));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password || !user) {
      toast.error(t("member_fill_all_fields"), {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      if (!password) setvPassword(true);
      else setvPassword(false);

      return;
    }

    const json = {
      Username: `${username}${suffix1}${suffix2}${suffix3}`,
      Password: password,
      position: "sub_account",
      agent: user,
      status: status,
      permissions: permission.map((p) => ({ PermissionID: p, status: 1 })),
    };

    ApiConfig.post("/subadregister", json).then((result) => {
      if (result.resCode === 200) {
        setUsername("");
        setPassword("");
        setOpen(false);
        setReload((r) => r + 1);
        toast.success(t("subaccount_add_success"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else if (result.resCode === 422) {
        toast.error(t("subaccount_duplicate_username"), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(result.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  };

  const pos = localStorage.getItem("position");

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("subaccount_page_title")} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <div
              className="p-1 mb-1 bg-brand-blue-800 h-[2em] w-auto inline-flex items-center text-white rounded border-solid hover:bg-sky-800 cursor-pointer"
              onClick={handleClickOpen}
            >
              <GroupAddIcon sx={{ fontSize: 16 }} className="ml-1" />
              <span className="ml-1 text-xs font-bold">
                {t("subaccount_add_button")}
              </span>
            </div>
            <SubAccouttable externalReload={reload} />
            {open && (
              <div>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <div className="App">
                    <form onSubmit={handleSubmit}>
                      <DialogTitle
                        className="text-white bg-brand-blue-800"
                        id="alert-dialog-title"
                      >
                        {t("subaccount_add_button")}
                      </DialogTitle>
                      <DialogContent>
                        <div className="grid grid-cols-2 p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4">
                          <div>
                            <label
                              htmlFor="username"
                              className="block mb-1 font-bold"
                            >
                              {t("login_username_label")}
                            </label>
                            <div className="flex items-center">
                              <div id="user-prefix">
                                <span className="px-3 py-2 rounded-l-lg font-bold text-gray-700 select-none">
                                  {prefix}
                                </span>
                              </div>
                              <div id="acctIdSuffix1">
                                <select
                                  id="acctIdSuffix1"
                                  value={suffix1}
                                  onChange={(e) => setSuffix1(e.target.value)}
                                  className="w-auto text-[15px] px-3 py-2 text-gray-700 bg-slate-150 border-b-[2px] rounded-none focus:outline-none focus:border-blue-500"
                                >
                                  {[
                                    ...Array.from({ length: 10 }, (_, i) =>
                                      String(i),
                                    ),
                                    ...Array.from({ length: 26 }, (_, i) =>
                                      String.fromCharCode(65 + i),
                                    ),
                                  ].map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div id="acctIdSuffix2">
                                <select
                                  id="acctIdSuffix2"
                                  value={suffix2}
                                  onChange={(e) => setSuffix2(e.target.value)}
                                  className="w-auto text-[15px] px-3 py-2 text-gray-700 bg-slate-150 border-b-[2px] rounded-none focus:outline-none focus:border-blue-500"
                                >
                                  {[
                                    ...Array.from({ length: 10 }, (_, i) =>
                                      String(i),
                                    ),
                                    ...Array.from({ length: 26 }, (_, i) =>
                                      String.fromCharCode(65 + i),
                                    ),
                                  ].map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div id="acctIdSuffix3">
                                <select
                                  id="acctIdSuffix3"
                                  value={suffix3}
                                  onChange={(e) => setSuffix3(e.target.value)}
                                  className="w-auto text-[15px] px-3 py-2 text-gray-700 bg-slate-150 border-b-[2px] rounded-none focus:outline-none focus:border-blue-500"
                                >
                                  {[
                                    ...Array.from({ length: 10 }, (_, i) =>
                                      String(i),
                                    ),
                                    ...Array.from({ length: 26 }, (_, i) =>
                                      String.fromCharCode(65 + i),
                                    ),
                                  ].map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="password"
                              className="block mb-1 font-bold"
                            >
                              {t("login_password_label")}
                            </label>
                            <input
                              type="password"
                              id="password"
                              value={password}
                              placeholder="Password"
                              onChange={(e) => setPassword(e.target.value)}
                              className="w-auto text-[15px] px-3 py-2 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                            />
                            {vpassword ? (
                              <p className="pl-1 text-red-500">
                                {t("member_field_required")}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>

                          <div>
                            <label className="block mb-1 font-bold">
                              {t("subaccount_status_label")}
                            </label>
                            <select
                              onChange={(e) => setStatus(e.target.value)}
                              name="status"
                              id="status"
                            >
                              <option value={1}>
                                {t("subaccount_status_active")}
                              </option>
                              <option value={0}>
                                {t("subaccount_status_inactive")}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div className="grid grid-rows p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4">
                          <label htmlFor="bank" className="mb-1 font-bold">
                            {t("subaccount_permissions_label")}
                          </label>

                          <label>
                            <input
                              type="checkbox"
                              className="mr-2 accent-blue-500"
                              checked={
                                permissions.length > 0 &&
                                permission.length === permissions.length
                              }
                              onChange={handleSelectAllPermissions}
                            />
                            {t("subaccount_select_all")}
                          </label>

                          <div className="flex flex-col gap-2 max-h-[50vh] overflow-y-auto pr-1">
                            {Object.entries(groupPermissions(permissions)).map(
                              ([category, items]) => (
                                <div
                                  key={category}
                                  className="grid grid-cols-2 p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4"
                                >
                                  <label className="col-span-2 block mb-1 font-bold">
                                    {t(getPermissionCategoryLabelKey(category))}
                                  </label>
                                  {items.map((item) => (
                                    <label key={item.id}>
                                      <input
                                        type="checkbox"
                                        className="mr-2 accent-blue-500"
                                        checked={permission.includes(item.id)}
                                        value={item.id}
                                        onChange={() =>
                                          handlepermission(item.id)
                                        }
                                      />
                                      {getPermissionLabel(item, t)}
                                    </label>
                                  ))}
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <button
                          type="submit"
                          className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                        >
                          <AddBoxIcon /> {t("subaccount_add_button")}
                        </button>
                        <button
                          onClick={handleClose}
                          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                        >
                          {t("common_cancel")}
                        </button>
                      </DialogActions>
                    </form>
                  </div>
                </Dialog>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Subaccount;
